





































































import { ExportAllItensUseCase, ImportaItensUseCase } from '@/usecases';
import { Component, Vue } from 'vue-property-decorator';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { uploadFilesToS3 } from '@/shareds/s3/files';

@Component
export default class DialogoDeImportacaoTabelaDePrecos extends Vue {
	mostra = false
	tab: null | number = null
	tabs = [
		{ action: 'Importar', icon: 'mdi-file-upload' },
	]
	exportAllItensUseCase = new ExportAllItensUseCase()
	importaItensUseCase = new ImportaItensUseCase()
	importando = false
	exportando = false
	arquivoContemCabecalho = false
	arquivoCsv: File[] = []
	tabelaNome: string | null = null
	tabelaIds: string[] = []
	selecionado: boolean | null = null

	async mostrar(tabelaIds: string[]) {
		this.tabelaIds = tabelaIds || []
		this.mostra = true
	}

	cancelar() {
		this.importando = false
		this.mostra = false
		this.arquivoCsv = []
		this.arquivoContemCabecalho = false
	}

	async concluirImportacao() {
		if (this.arquivoCsv.length == 0) {
			return AlertModule.setError("É obrigatório selecionar um arquivo")
		}
		if (!this.tabelaIds.length) {
			return AlertModule.setError("Selecione ao menos uma tabela")
		}

		try {
			this.importando = true;

			const informacoesDosArquivos = await uploadFilesToS3(
				this.arquivoCsv,
				`importacao-tabela-de-preco`,
			)
			const urlDoArquivo = informacoesDosArquivos.map(({ config }) => config.url)[0]

			if (!urlDoArquivo) {
				return AlertModule.setError("Ocorreu um erro interno, contate o suporte")
			}
			
			await this.importaItensUseCase.importacaoMultiplasTabelas({
				tabelasIds: this.tabelaIds,
				urlDoArquivoCsv: urlDoArquivo,
				arquivoContemCabecalho: this.arquivoContemCabecalho,
			})

			AlertModule.setSuccess('Itens em processamento')
			this.$emit('concluiuImportacao')
		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.importando = false
			this.arquivoCsv = []
			this.mostra = false
			this.arquivoContemCabecalho = false
			this.tabelaIds = []
		}
	}
}
